import { useContext } from 'react';
import type { Context } from '@/types';
import { AppContext } from './context';

export const useApp = () => useContext<Context>(AppContext);
